import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { money } from "@/lib/api";

export function ProductCard({ p, dark = false, index = 0 }) {
  const { add } = useCart();
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group"
      data-testid={`product-card-${p.slug}`}
    >
      <Link to={`/product/${p.slug}`} className="relative block aspect-[4/5] overflow-hidden rounded-2xl bg-[var(--sand)]">
        <img src={p.image} alt={p.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-[transform,opacity] duration-700 ease-out group-hover:scale-105" />
        {p.alt_image && (
          <img src={p.alt_image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
        )}
        {p.badge && (
          <span className="eyebrow absolute left-3 top-3 rounded-full bg-[var(--bone)] px-3 py-1.5 !text-[10px] text-[var(--ink)]">{p.badge}</span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); add(p); }}
          disabled={p.stock <= 0}
          className="absolute bottom-3 right-3 grid h-11 w-11 place-items-center rounded-full bg-[var(--ink)] text-[var(--bone)] shadow-lg transition-[transform,background-color] duration-300 hover:scale-110 hover:bg-[var(--terra)] disabled:opacity-40 md:translate-y-2 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100"
          aria-label={`Add ${p.name} to bag`}
          data-testid={`quick-add-${p.slug}`}
        >
          <Plus size={18} />
        </button>
      </Link>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <p className={`eyebrow !text-[10px] ${dark ? "text-stone-400" : "text-[var(--ink-soft)]"}`}>{p.category}</p>
          <Link to={`/product/${p.slug}`} className="mt-1 block text-sm font-semibold leading-snug sm:text-base">{p.name}</Link>
        </div>
        <div className="text-right">
          <p className="text-sm font-semibold sm:text-base">{money(p.price)}</p>
          {p.compare_at && <p className={`text-xs line-through ${dark ? "text-stone-400" : "text-[var(--ink-soft)]"}`}>{money(p.compare_at)}</p>}
        </div>
      </div>
    </motion.div>
  );
}
